import { createDomainStore } from '../../storage/create-domain-store';
import { DomainStoreType } from '../../storage/types/domain-store';
import { defaultFilterDomainState } from './state';
export const filterDomainStore = createDomainStore({
    type: DomainStoreType.BrowserSession,
    defaultState: defaultFilterDomainState,
    name: 'filter-domain-store'
});
